module.exports = __webpack_public_path__ + "static/media/ic_list.2a242582.svg";